
import './App.css';
import { Router, Routes, Route } from "react-router";
import { BrowserRouter } from 'react-router-dom'
import Header from "./componentes/Header.js";
import Home from "./componentes/Home.js";
import Bases from "./componentes/Bases";
import Footer from './componentes/Footer';
import Registro from './componentes/Registro';
function App() {
  return (
    <div className="App">
      <BrowserRouter basename='/Calaveritas2023/'>
        <Header />
        <Routes>
          <Route path="/bases" element={<Bases />} />
          <Route path="/" element={<Home />} />
          <Route path="/registro_calaverita" element={<Registro/>} />
        </Routes>
        <Footer/>
      </BrowserRouter>
      
    </div>
  );
}

export default App;
